import React from "react";
import { Link } from "react-router-dom";

/* global __BUILD_SHA__, __BUILD_AT__ */
const BUILD_SHORT = String(typeof __BUILD_SHA__ !== "undefined" ? __BUILD_SHA__ : "dev").slice(0, 7);
const BUILD_AT_LABEL = (() => {
  try {
    const d = new Date(typeof __BUILD_AT__ !== "undefined" ? __BUILD_AT__ : "");
    return Number.isNaN(d.getTime()) ? "" : d.toISOString().slice(0, 16).replace("T", " ") + " UTC";
  } catch (_) { return ""; }
})();

const Footer = () => {
  return (
    <div className="text-white w-full mt-12">
      <div className="border-t border-gray-600" />
      <footer className="w-full bg-[#0b0d2a] text-gray-300 relative">
        {/* Main Footer Content */}
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Company Info */}
            <div className="flex-1 min-w-0">
              <img src="/logojt.png" alt="JTNC Logo" className="w-[80%] max-w-[300px] ml-[-30px] mt-[-50px]" />

              <div className="space-y-2 text-sm sm:text-base">
                <p>Email: info@JTNCgroup.com</p>
                <p>732 S 6TH ST, STE R </p>
                <p>Las Vegas, NV 89101</p>
                <p>Phone: (702) 518-0915</p>
              </div>
            </div>

            {/* Legal */}
            <div className="flex-1 min-w-0">
              <h3 className="text-white font-semibold mb-4 text-base sm:text-lg">Legal</h3>
              <ul className="space-y-2 text-sm sm:text-base">
                <li>
                  <Link
                    to="/disclaimer"
                    className="hover:text-white transition-colors"
                  >
                    Disclaimer
                  </Link>
                </li>
                <li>
                  <Link
                    to="/privacy"
                    className="hover:text-white transition-colors"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/terms"
                    className="hover:text-white transition-colors"
                  >
                    Terms and Conditions
                  </Link>
                </li>
                <li>
                  <Link
                    to="/refund-and-cancellation"
                    className="hover:text-white transition-colors"
                  >
                    Refund and Cancellation Policy
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-gray-700">
            <p className="text-gray-500 leading-relaxed text-xs sm:text-sm">
              The information contained on this website is solely for educational purposes, and does not constitute investment advice. The risk of trading in securities markets can be substantial. You must review and agree to our Disclaimers and Terms and Conditions before using this site.
              <br /><br />
              U.S. Government Required Disclaimer - Commodity Futures Trading Commission. Futures and options trading has large potential rewards, but also large potential risk. You must be aware of the risks and be willing to accept them in order to invest in the futures and options markets. Don't trade with money you can't afford to lose. This website is neither a solicitation nor an offer to Buy/Sell futures or options. No representation is being made that any account will or is likely to achieve profits or losses similar to those discussed on this website. The past performance of any trading system or methodology is not necessarily indicative of future results.
              <br /><br />
              Individual results may vary, and testimonials are not claimed to represent typical results. All testimonials are by real people, and may not reflect the typical purchaser's experience, and are not intended to represent or guarantee that anyone will achieve the same or similar results.
              <br /><br />
              JTNCgroup Trader's and employees will NEVER manage or offer to manage a customer or individual's options, stocks, currencies, futures, or any financial markets or securities account. If someone claiming to represent or be associated with JTNCgroup solicits you for money or offers to manage your trading account, do not provide any personal information and contact us immediately.
              <br /><br />
              CFTC RULE 4.41 - HYPOTHETICAL OR SIMULATED PERFORMANCE RESULTS HAVE CERTAIN LIMITATIONS. UNLIKE AN ACTUAL PERFORMANCE RECORD, SIMULATED RESULTS DO NOT REPRESENT ACTUAL TRADING. ALSO, SINCE THE TRADES HAVE NOT BEEN EXECUTED, THE RESULTS MAY HAVE UNDER-OR-OVER COMPENSATED FOR THE IMPACT, IF ANY, OF CERTAIN MARKET FACTORS, SUCH AS LACK OF LIQUIDITY, SIMULATED TRADING PROGRAMS IN GENERAL ARE ALSO SUBJECT TO THE FACT THAT THEY ARE DESIGNED WITH THE BENEFIT OF HINDSIGHT. NO REPRESENTATION IS BEING MADE THAT ANY ACCOUNT WILL OR IS LIKELY TO ACHIEVE PROFIT OR LOSSES SIMILAR TO THOSE SHOWN.
            </p>
          </div>

          {/* Copyright */}
          <div className="mt-6 sm:mt-8 text-center text-gray-500 text-xs sm:text-sm">
            <p>
              © {new Date().getFullYear()} JTNCgroup.com. All rights reserved
            </p>
            {/* Build ID: which commit this page was built from, and when. Injected at build
                time by vite.config.js (define). Also served as /version.json by the deploy. */}
            <p className="mt-2 font-mono text-[11px] text-gray-600" data-build={BUILD_SHORT}>
              build {BUILD_SHORT} · {BUILD_AT_LABEL}
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;

